import clsx from 'clsx'
import { useRouter } from 'next/router'
import { type FC, type ReactNode, useEffect } from 'react'

import MavisLoading from '~/components/MavisLoading'
import { toUrlSSOLogin } from '~/configs/auth'
import { removeAuthCookies } from '~/core/cookie'
import { useSentry } from '~/core/sentry'
import { useAuthContext } from '~/hooks/useAuthContext'

import { Header } from '../Header'

type LayoutProps = {
  children: ReactNode
  full?: boolean
}

export const Layout: FC<LayoutProps> = ({ children, full }) => {
  const router = useRouter()
  const { isFetched, user, getProfile, getSettings, getMFAMethods } =
    useAuthContext()
  const { captureException } = useSentry()

  const handleLoadUser = async () => {
    try {
      await Promise.all([getSettings(), getProfile(), getMFAMethods()])
    } catch (error) {
      captureException(error)
    }
  }

  const handleRedirectSSO = () => {
    removeAuthCookies()
    const urlSSO = toUrlSSOLogin()
    router.replace(urlSSO)
  }

  useEffect(() => {
    if (!user && isFetched) {
      handleRedirectSSO()
      return
    }

    if (!user && !isFetched) {
      handleLoadUser()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router, user, isFetched])

  if (!user || !isFetched) {
    return <MavisLoading text="Loading" redirect="/" />
  }

  return (
    <div className="h-screen">
      <Header />
      <div className="matcha-scroll-container">
        <div className="matcha-content-wrapper">
          <div className={clsx({ 'matcha-content-inner': !full })}>
            {children}
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </div>
  )
}
